import riot from 'riot';
import events from '../src/events.js';
import { getProjects as libGetProjects } from '../src/lib.js';
riot.tag2('projects', '<div class="column is-12" style="margin-top: -75px;"> <nav class="navbar" role="navigation" aria-label="main navigation" if="{!selectedProject && !showBuildProject}" style="background-color: rgb(245,245,245);"> <div class="navbar-menu is-active"> <div class="navbar-start"> <div class="navbar-item"> <div class="field has-addons has-addons-centered"> <div class="control"> <input class="input" type="text" oninput="{filterProjects}" id="filterProjectsInput" placeholder="Search Projects"> </div> <div class="control"> <a class="button is-info" onclick="{filterProjects}"> <span class="icon is-small"> <i class="fas fa-search"></i> </span> </a> </div> </div> </div> <div class="navbar-item"> <div class="field is-grouped"> <div class="control"> <button class="button {myProjectsFilterActive ? \'is-info\' : \'is-info is-light\'}" type="button" onclick="{toggleMyProjectsFilter}" show="{user}"> <span class="icon is-small"><i class="fas fa-user"></i></span> <span>{myProjectsFilterActive ? \'Show All Projects\' : \'Show My Projects\'}</span> </button> </div> <div class="control"> <button class="button {showCommunityContent ? \'is-link\' : \'is-link is-light\'}" type="button" onclick="{toggleCommunityContent}"> <span class="icon is-small"><i class="fas fa-globe"></i></span> <span>{showCommunityContent ? \'Hide Community\' : \'Show Community\'}</span> </button> </div> <div class="control" if="{hasActiveProjectFilters()}"> <button class="button is-light" onclick="{clearProjectFilters}"> <span class="icon is-small"> <i class="fas fa-times"></i> </span> <span>Clear Filters</span> </button> </div> </div> </div> </div> <div class="navbar-end"> <div class="navbar-item"> <div class="buttons"> <button class="button is-success" onclick="{buildProjectClick}" if="{user}"> <span class="icon is-small"> <i class="fas fa-plus"></i> </span> <span>Create New Project</span> </button> <button class="button is-warning" onclick="{refreshClick}"> <span class="icon is-small"> <i class="fas fa-sync"></i> </span> </button> </div> </div> </div> </div> </nav> <div class="container is-fluid has-text-centered" show="{loading_projects}" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> <div class="columns is-multiline" if="{!loading_projects && !selectedProject && !showBuildProject}" style="margin-top: 5px;"> <div class="column is-4" each="{l in filteredProjects}" if="{!projects_error}"> <div class="card" style="display:flex; flex-direction:column; height:100%;"> <div class="card-content" style="display: flex; flex-direction: column; flex: 1 1 auto;"> <div class="media"> <div class="media-left"> <figure class="image is-48x48"> <img riot-src="img/{l.icon}" alt="Projects Icon" onerror="this.onerror=null; this.src=\'img/brand/Edjro_Logo_Mark_Navy.png\';"> </figure> </div> <div class="media-content"> <p class="title is-4">{l.name}</p> <p class="subtitle is-6">Author: {l.author?l.author.first_name + ⁗ ⁗ + l.author.last_name:⁗⁗}</p> </div> </div> <div class="notification is-info is-light has-text-centered" if="{l.status === \'draft\'}"> <span class="icon"><i class="fas fa-pencil-alt"></i></span> Draft — Only visible to you </div> <div class="notification is-warning is-light has-text-centered" if="{projectHasActivity(l)}"> In Progress </div> <div class="content" style="display: flex; flex-direction: column; flex: 1 1 auto;"> <p>{l.description}</p> <div class="buttons" style="margin-top: auto"> <button id="viewDetails" class="button is-info" onclick="{selectProject}"> View Project Details </button> </div> </div> </div> </div> <div class="column is-12" if="{projects_error}"> <article class="message is-danger"> <div class="message-header"> <p>Oh No!</p> <button class="delete" aria-label="delete"></button> </div> <div class="message-body"> It looks like there was an error loading the projects from the library! Try to refresh the page and if the problem persists, please check out status page to see if there are any ongoing issues. Thank you for you patience! <button class="button is-warning" onclick="{refreshClick}"> <span class="icon is-small"> <i class="fas fa-sync"></i> </span> <span>Refresh Projects</span> </button> </div> </article> </div> </div> </div> <project-details if="{selectedProject}"></project-details> <lesson-build if="{showBuildProject}" build_type="project" edit_mode="{editMode}" lesson_to_edit="{projectToEdit}"></lesson-build> </div>', '', '', function(opts) {
        var self = this;
        self.loading_projects = false;
        self.selectedProject = undefined;
        self.devices = undefined;
        self.startingActivity = false;
        self.showBuildProject = false;
        self.editMode = false;
        self.projectToEdit = undefined;
        self.userActivities = undefined;
        self.projects = [];
        self.filteredProjects = [];
        self.showCommunityContent = false;
        self.dataLoaded = false;

        self.on('mount', function() {
            getProjects();
            getUser();
        });

        events.on('auth_complete', function() {
            self.user = 1;
            self.update();
        });

        events.on('users_loaded', function(user) {
            getUser();

            self.dataLoaded = false;
            getProjects();
        });

        events.on('devices_loaded', function(devices) {
            self.devices = devices;
            self.update();
        });

        events.on('activities_loaded', function(activities) {
            self.userActivities = activities;
            self.update();
        });

        events.on('navigate_to_project', function(payload) {
            const { project_id, view, params } = payload || {};
            if (project_id && self.projects) {
                if (project_id == "build") {
                    self.showBuildProject = true;
                    self.editMode = false;
                    self.projectToEdit = undefined;
                    self.update();
                    return;
                }
                getLoadedProjectById(project_id);
                self.update();
            } else if (self.projects) {
                self.unselectProject();
            } else {

            }
        });

        events.on('navigate_to_project_edit', function(payload) {
            self.selectedProject = undefined;
            self.showBuildProject = true;
            self.editMode = true;
            self.projectToEdit = payload.project;
            self.update();
        });

        self.myProjectsFilterActive = false;

        self.toggleMyProjectsFilter = function() {
            self.myProjectsFilterActive = !self.myProjectsFilterActive;
            self.filterProjects();
        };

        self.toggleCommunityContent = function() {
            self.showCommunityContent = !self.showCommunityContent;
            self.filterProjects();
        };

        self.clearProjectFilters = function() {
            document.getElementById('filterProjectsInput').value = '';
            self.myProjectsFilterActive = false;
            self.filteredProjects = self.showCommunityContent ? self.projects : self.projects.filter(function(p) { return isOfficialOrMyContent(p); });
            self.update();
        };

        self.hasActiveProjectFilters = function() {
            var searchInput = document.getElementById('filterProjectsInput');
            var hasSearchText = searchInput && searchInput.value.trim() !== '';
            var hasMyProjects = !!self.myProjectsFilterActive;
            return hasSearchText || hasMyProjects;
        };

        this.projectHasActivity = function(p) {
            if (self.userActivities) {
                for (i = 0; i < self.userActivities.length; i++) {
                    if (self.userActivities[i].lesson_id == p.id && self.userActivities[i].active) {
                        return true;
                    }
                }
            }
            return false;
        }.bind(this)

        this.refreshClick = function(e) {
            self.projects_error = undefined;
            self.dataLoaded = false;
            getProjects()
        }.bind(this)

        this.filterProjects = function(e) {
            var input = document.getElementById('filterProjectsInput');
            var filter = input.value.trim().toLowerCase();
            var userId = self.user && self.user.user_id;
            self.filteredProjects = [];
            for (var i = 0; i < self.projects.length; i++) {
                var project = self.projects[i];

                var matchesText = false;
                if (!filter) {
                    matchesText = true;
                } else {
                    if (project.name && project.name.toLowerCase().indexOf(filter) > -1) matchesText = true;
                    if (project.author && project.author.first_name && project.author.last_name) {
                        var author = (project.author.first_name + ' ' + project.author.last_name).toLowerCase();
                        if (author.indexOf(filter) > -1) matchesText = true;
                    }
                }

                var matchesVisibility = false;
                if (self.myProjectsFilterActive) {
                    if (userId && project.author && project.author.id == userId) {
                        matchesVisibility = true;
                    }
                } else if (self.showCommunityContent) {
                    matchesVisibility = true;
                } else {
                    matchesVisibility = isOfficialOrMyContent(project);
                }

                if (matchesText && matchesVisibility && self.filteredProjects.indexOf(project) === -1) {
                    self.filteredProjects.push(project);
                }
            }
            self.update();
        }.bind(this)

        this.unselectProject = function() {
            self.selectedProject = undefined;
            route("projects", "Projects")
            self.update();
        }.bind(this)

        this.selectProject = function(e) {

            route('projects/' + e.item.l.id, "Project Details");
            self.update();
        }.bind(this)

        this.startActivityClick = function(e) {

            self.startingActivity = true;
            self.selectProject(e);
        }.bind(this)

        this.buildProjectClick = function(e) {
            self.showBuildProject = true;
            self.editMode = false;
            self.projectToEdit = undefined;
            self.update();
            route("projects/build", "Build Project");
        }.bind(this)

        this.exitBuildProject = function() {
            self.showBuildProject = false;
            self.editMode = false;
            self.projectToEdit = undefined;
            route("projects", "Projects")
            getProjects();
        }.bind(this)

        this.getStatusTag = function(s) {
            if (s == "Inactive") {
                return "light"
            } else if (s == "Error") {
                return "danger"
            } else if (s == "In Unit") {
                return "success"
            } else {
                return "warning"
            }
        }.bind(this)

        function getUser() {
            user_profile = localStorage.getItem('profile');
            if (user_profile != "undefined") {
                self.update({
                    user: JSON.parse(user_profile)
                });
            }
        };

        function isOfficialOrMyContent(item) {
            if (!item.author) return true;
            var userId = self.user && self.user.user_id;
            if (userId && item.author.id == userId) return true;
            var authorName = ((item.author.first_name || '') + ' ' + (item.author.last_name || '')).toLowerCase().trim();
            if (authorName.indexOf('edjro') > -1 || authorName.indexOf('filament') > -1) return true;
            return false;
        }

        function getLoadedProjectById(id) {
            console.log("Getting Project by ID: " + id)
            console.log(self.projects)
            for (i = 0; i < self.projects.length; i++) {
                if (self.projects[i].id == id) {
                    self.selectedProject = self.projects[i];
                    break;
                }
            }
            console.log(self.selectedProject)
        }

        function getProjects() {

            if (self.loading_projects) {
                return;
            }

            self.loading_projects = true;
            libGetProjects().then(function(res) {
                self.loading_projects = false;
                self.dataLoaded = true;
                var initialFiltered = self.showCommunityContent ? res['data']['projects'] : res['data']['projects'].filter(function(p) { return isOfficialOrMyContent(p); });
                self.update({
                    projects: res['data']['projects'],
                    filteredProjects: initialFiltered,
                    projects_error: undefined
                });

                if (!window.appData) {
                    window.appData = {};
                }

                window.appData.projects = res['data']['projects'];

                events.emit('projects_loaded', res['data']['projects']);

                route.exec();
            }).catch(function(error) {
                console.error('projects Error:' + error);
                self.loading_projects = false;
                self.dataLoaded = false;
                self.update({
                    projects: [],
                    filteredProjects: [],
                    projects_error: error
                });
            });

        }
});
